import { useEffect } from 'react'
import { useSearchParams } from 'react-router'

export function useRedirectFromOldDrawerQueryParams() {
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    const oldTriage = searchParams.get('finding-triage')
    const oldFix = searchParams.get('finding-fix')
    if (!oldTriage && !oldFix) return

    setSearchParams(
      prev => {
        const next = new URLSearchParams(prev)
        if (oldTriage && !next.has('triage-finding-id')) {
          next.set('triage-finding-id', oldTriage)
        }
        next.delete('finding-triage')
        if (oldFix && !next.has('fix-finding-id')) {
          next.set('fix-finding-id', oldFix)
        }
        next.delete('finding-fix')
        return next
      },
      { replace: true }
    )
  }, [searchParams, setSearchParams])
}
